<template>
  <v-fade-transition v-if="activeMappedItem">
    <div>
      <!-- A row with the title and the button to save -->
      <v-layout align-center>
        <!-- The title of the input -->
        <v-flex>
          <v-subheader>Valor personalizado</v-subheader>
        </v-flex>
        <!-- The button to save -->
        <v-flex shrink>
          <v-btn @click="save" color="green" flat :loading="loadingSaveActiveMap">
            <v-icon>check</v-icon>
            <span class="pl-2">Guardar</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- The tile of the list with the input -->
      <v-list-tile>
        <v-text-field
          v-model="input"
          class="pt-0 mt-0"
          :error="inputError"
          hide-details
          @keyup.enter="save"
          placeholder="Escribe aquí el valor personalizado"
          ref="input"
        />
      </v-list-tile>
    </div>
  </v-fade-transition>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { EmptyActiveMappedItemInput } from "@/store/value-mapping/exceptions.js";

export default {
  data: () => ({
    inputError: false
  }),
  computed: {
    ...mapState("valueMapping", [
      "activeMappedItem",
      "activeMappedItemInput",
      "loadingSaveActiveMap"
    ]),
    input: {
      get() {
        return this.activeMappedItemInput;
      },
      set(val) {
        this.setActiveMappedItemInput(val);
      }
    }
  },
  methods: {
    ...mapActions("valueMapping", ["saveActiveMap"]),
    ...mapMutations("valueMapping", ["setActiveMappedItemInput"]),
    save() {
      this.saveActiveMap()
        .then(() => (this.inputError = false))
        .catch(error => {
          if (error instanceof EmptyActiveMappedItemInput) {
            this.inputError = true;
            this.$refs.input.focus();
            return this.$notify.error("Por favor ingresa un valor");
          }
        });
    }
  }
};
</script>